import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SpendByVendorChart = ({ transactions }) => {
  // Group transactions by vendor
  const groupedData = transactions.reduce((acc, txn) => {
    const vendorName = txn.vendor?.name || txn.vendor || 'Unknown Vendor';

    if (!acc[vendorName]) {
      acc[vendorName] = {
        vendorName,
        totalSpend: 0,
        transactionCount: 0
      };
    }

    acc[vendorName].totalSpend += parseFloat(txn.amount || 0);
    acc[vendorName].transactionCount += 1;

    return acc;
  }, {});

  // Convert to array, sort by total spend, and take top 15
  const chartData = Object.values(groupedData)
    .sort((a, b) => b.totalSpend - a.totalSpend)
    .slice(0, 15);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3">
          <p className="text-sm font-semibold text-gray-900">
            {payload[0].payload.vendorName}
          </p>
          <p className="text-sm text-gray-700 mt-1">
            Total Spend: <span className="font-semibold">{formatCurrency(payload[0].value)}</span>
          </p>
          <p className="text-sm text-gray-600">
            Transactions: {payload[0].payload.transactionCount}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Spend by Vendor (Top 15)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            dataKey="vendorName"
            tick={{ fontSize: 11, fill: '#6b7280' }}
            stroke="#9ca3af"
            angle={-45}
            textAnchor="end"
            height={100}
            interval={0}
          />
          <YAxis
            tickFormatter={formatCurrency}
            tick={{ fontSize: 12, fill: '#6b7280' }}
            stroke="#9ca3af"
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="totalSpend"
            fill="#f59e0b"
            name="Total Spend"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SpendByVendorChart;
